<template>
  <v-row class="main-container">
    <!-- new quotation dialog -->
    <dialog-new-quotation
      v-if="dialogNewQuotation"
      :dialog="dialogNewQuotation"
      v-on:dialog-close="onDialogNewQuotationClose"
    ></dialog-new-quotation>

    <dialog-manage-quotation
      v-if="dialogManageQuotation"
      :dialog="dialogManageQuotation"
      v-model="selectedQuotation"
      v-on:dialog-close="onDialogManageQuotationClose"
    ></dialog-manage-quotation>

    <dialog-quotation-overview
      :quotation="selectedQuotationOverview"
      :dialog="dialogQuotationOverview"
      v-on:dialog-close="onDialogClose"
    ></dialog-quotation-overview>

    <!-- <dialog-manage-invoice
      :dialog="dialogManageInvoice"
      v-model="selectedInvoice"
      v-on:dialog-close="onDialogClose"
    ></dialog-manage-invoice> -->

    <dialog-quotation-files
      :quotation="selectedQuotation"
      :dialog="dialogQuotationFiles"
      v-on:dialog-close="onDialogClose"
    ></dialog-quotation-files>

    <!-- Dialog for Comment Message Box -->
    <dialog-message-box
      :dialog="dialogMessageBox"
      v-model="selectedQuotation"
      :title="messageBoxTitle"
      :quotation_id="messageBoxQuotationId"
      :invoice_id="messageBoxInvoiceId"
      :company_id="messageBoxCompanyId"
      :company_name="messageBoxCompanyName"
      :category="messageBoxCategory"
      :tags="messageBoxTags"
      v-on:dialog-close="onDialogClose"
    ></dialog-message-box>

    <!-- Dialog for managing booking files upload -->
    <dialog-file-cabinet
      v-model="selectedShipmentId"
      :company_id="selectedCompanyId"
      :dialog="dialogFileCabinet"
      :isBooking="true"
      v-on:dialog-close="onDialogClose"
    ></dialog-file-cabinet>

    <!-- warning dialog -->
    <v-dialog v-model="dialogOnConfirmQuotation" max-width="450">
      <v-card v-if="selected_tbc_quotation != null" color="white" tile flat>
        <v-card-title class="dialog-header-title"
          >Confirm Quotation</v-card-title
        >
        <v-card-text class="mt-3">
          <v-alert tile outlined type="info" border="left" dense>
            <span>
              Upon confirming quotation
              <strong>{{ selected_tbc_quotation.quotation_id }},</strong> the
              booking process will begin.
            </span>
            <br />
            <br />
            <span>Do you want to proceed?</span>
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-row justify="end" class="mb-2">
            <v-btn
              class="mr-2 font-weight-bold text-button"
              color="primary"
              depressed
              tile
              small
              @click="confirmQuotation(selected_tbc_quotation)"
              >YES</v-btn
            >
            <v-btn
              class="ml-2 font-weight-bold text-button"
              color="error"
              tile
              small
              depressed
              @click="dialogOnConfirmQuotation = false"
              >NO</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End warning dialog -->

    <!-- Send Quotation -->
    <v-dialog
      v-model="dialogSendQuotation"
      persistent
      scrollable
      max-width="650"
    >
      <v-card tile flat color="white">
        <v-card-title class="dialog-header-title pr-2">
          <v-row no-gutters>
            <v-col>
              <span class="title font-weight-bold">Send Quotation</span>
            </v-col>

            <v-col cols="1" class="d-flex justify-content-end">
              <v-icon
                size="30"
                color="white"
                @click="dialogSendQuotation = false"
                >mdi-close</v-icon
              >
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text class="px-4 pt-4">
          <v-row no-gutters>
            <v-col cols="2">
              <span class="font-weight-bold caption">From:</span>
            </v-col>
            <v-col>
              <span class="font-weight-bold caption">{{
                email_data.from
              }}</span>
            </v-col>
          </v-row>

          <v-row>
            <v-divider class="my-3"></v-divider>
          </v-row>

          <v-row>
            <v-text-field
              label="To:"
              :rules="[rules.required, rules.email]"
              hide-details="auto"
              dense
              class="em-text-field body-2 primary--text mb-3"
              outlined
              v-model="email_data.to"
            ></v-text-field>
          </v-row>

          <v-row>
            <v-text-field
              label="Subject:"
              hide-details
              dense
              class="em-text-field body-2 font-weight-bold primary--text mb-3"
              outlined
              v-model="email_data.subject"
            ></v-text-field>
          </v-row>

          <v-row no-gutters class="pt-3">
            <v-col>
              <!-- <vue-editor v-model="email_data.body" :editorToolbar="customToolbar"></vue-editor> -->
              <v-textarea
                class="modified-text-field caption mb-3"
                dense
                outlined
                auto-grow
                hide-details
                rows="10"
                v-model="email_data.body"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <span class="caption primary--text"
              >A copy will be sent to you</span
            >
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row justify="end">
            <v-btn
              color="primary"
              class="font-weight-bold body-2 mr-2"
              depressed
              dark
              @click="sendQuotationEmail"
              >SEND</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Send Quotation -->

    <!-- warning dialog -->
    <v-dialog v-model="dialogAdminCreateShipment" max-width="500">
      <v-card v-if="selectedQuotationSync != null">
        <v-card-title class="dialog-header-title">Attention!!!</v-card-title>
        <v-card-text class="pt-2">
          <v-alert outlined type="warning" prominent border="left"
            >This quotation {{ selectedQuotationSync.quotation_id }} is not
            confirmed yet. Do you want to override and create a
            shipment?</v-alert
          >
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-row justify="end">
            <v-btn
              class="mx-2 font-weight-bold"
              color="primary"
              small
              depressed
              tile
              @click="adminCreateShipment"
              >CREATE SHIPMENT</v-btn
            >
            <v-btn
              class="ml-2 font-weight-bold"
              color="error"
              small
              depressed
              tile
              @click="onCloseAdminCreateShipment"
              >CANCEL</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog filter quotation list -->
    <v-dialog v-model="dialogFilterQuotation" max-width="900">
      <v-card flat tile color="white">
        <v-card-title class="dialog-header-title"
          >Filter quotation list</v-card-title
        >

        <v-card-text class="py-1 px-1">
          <v-row justify="center" class="py-2">
            <v-btn-toggle
              class="v-btn-toggle-new-quotation"
              mandatory
              dense
              v-model="selectedQuotationStatusFilter"
            >
              <v-btn text :value="0">All</v-btn>
              <v-btn v-if="$root.is_admin" text :value="1">Draft</v-btn>
              <v-btn text :value="2">Proposed</v-btn>
              <v-btn text :value="3">Confirmed</v-btn>
              <v-btn v-if="$root.is_admin" text :value="4">Trashed</v-btn>
            </v-btn-toggle>
          </v-row>

          <v-divider></v-divider>

          <v-row>
            <v-col cols="2">
              <span>Shipment type:</span>
              <v-select
                class="form-control rounded-0"
                placeholder="type"
                :items="shipmentTypeFilters"
                solo
                v-model="selectedShipmentTypeFilter"
                clearable
                clear-icon="mdi-close"
              ></v-select>
            </v-col>

            <v-col>
              <span>Origin port:</span>
              <v-autocomplete
                class="form-control rounded-0"
                solo
                placeholder="Select origin port"
                :items="sortedPortList"
                item-text="label"
                item-value="un_code"
                clearable
                v-model="selectedOriginPortFilter"
              >
                <template v-slot:item="data">
                  <v-list-item-content style="font-size: 90%">
                    <v-list-item-title
                      v-html="data.item.label"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-slot:item="data">
                  <img
                    :src="CONSTANT.getFlag(data.item.code_country)"
                    class="country-flag"
                  />
                  <v-list-item-content style="font-size: 90%">
                    <v-list-item-title
                      v-html="data.item.label"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col>
              <span>Destination port:</span>
              <v-autocomplete
                class="form-control rounded-0"
                solo
                placeholder="Select destination port"
                :items="sortedPortList"
                item-text="label"
                item-value="un_code"
                clearable
                v-model="selectedDestPortFilter"
              >
                <template v-slot:item="data">
                  <v-list-item-content style="font-size: 90%">
                    <v-list-item-title
                      v-html="data.item.label"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
                <template v-slot:item="data">
                  <img
                    :src="CONSTANT.getFlag(data.item.code_country)"
                    class="country-flag"
                  />
                  <v-list-item-content style="font-size: 90%">
                    <v-list-item-title
                      v-html="data.item.label"
                    ></v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-row>
            <v-divider class="mb-1"></v-divider>
          </v-row>

          <v-row>
            <v-col class="mr-4">
              <span>Company:</span>
              <v-autocomplete
                v-if="$root.is_admin"
                class="form-control rounded-0"
                :items="sortedCompanies"
                placeholder="Select Company Name"
                return-object
                v-model="selectedCompany"
                clearable
                item-text="name"
                solo
              ></v-autocomplete>
            </v-col>

            <v-col cols="3">
              <span class="pt-2 mr-2 black--text">Filter by:</span>
              <v-select
                class="form-control rounded-0"
                placeholder="Select date filter"
                :items="dateRangeFilters"
                item-text="label"
                item-value="id"
                solo
                v-model="selectedDateRangeFilter"
                clearable
                clear-icon="mdi-close"
                style="width: 100%"
              ></v-select>
            </v-col>

            <v-col cols="2">
              <span class="pt-2 mr-2 black--text">Start date:</span>
              <flat-pickr
                v-model="selectedStartFilter"
                placeholder="Select date"
                :config="config"
                name="date"
              ></flat-pickr>
            </v-col>

            <v-col cols="2">
              <span class="pt-2 mr-2 black--text">End date:</span>
              <flat-pickr
                v-model="selectedEndFilter"
                placeholder="Select date"
                :config="config"
                name="date"
              ></flat-pickr>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider class="my-1"></v-divider>

        <v-card-actions>
          <v-row justify="end">
            <v-btn
              color="primary"
              small
              tile
              depressed
              class="font-weight-bold mr-2"
              @click="onLoadFilteredQuotationList"
              >LOAD</v-btn
            >

            <v-btn
              color="error"
              small
              tile
              depressed
              class="font-weight-bold ml-2"
              @click="onCloseDialogQuotationFilter"
              >CLOSE</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <v-row no-gutters class="px-2">
      <v-col>
        <v-subheader class="headline pl-0 ml-0" style="color: #1976d2"
          >Quotations</v-subheader
        >
      </v-col>

      <v-col class="mt-2 d-flex justify-center">
        <v-btn
          class="font-weight-bold text-uppercase"
          small
          outlined
          tile
          color="primary"
          dark
          @click="onCreateQuotation"
          v-if="$root.allow_access"
          >Create Quotation</v-btn
        >
      </v-col>

      <v-col class="pt-1">
        <v-row justify="end">
          <input
            v-if="$root.is_admin"
            class="form-control mr-12 rounded-0"
            style="width: 33%"
            v-model="quotation_id_search"
            placeholder="Enter quotation id only"
            v-on:keyup.enter="initializeQuotationsList(false)"
          />
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-divider class="mt-0"></v-divider>
    </v-row>

    <v-row dense>
      <v-col>
        <af-pagination
          v-model="pagination"
          v-on:next="onNextPage"
          v-on:prev="onPrevPage"
          v-on:rows-per-page-change="onitemsPerPageChange"
        ></af-pagination>
      </v-col>

      <v-col cols="1" class="pr-2">
        <v-row justify="end">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                small
                class="mr-2"
                @click="onOpenDialogFilterQuotation"
              >
                <v-icon size="30" color="primary">{{
                  isResetFilter ? "mdi-filter-menu-outline" : "mdi-filter-menu"
                }}</v-icon>
              </v-btn>
            </template>
            Filter quotation list
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                small
                tile
                depressed
                icon
                color="primary"
                @click="onResetRefreshQuotationList"
              >
                <v-icon size="30">mdi-refresh</v-icon>
              </v-btn>
            </template>
            Reset filter
          </v-tooltip>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-divider class="mt-1"></v-divider>
    </v-row>

    <v-row no-gutters class="pa-2">
      <v-col cols="12" v-if="!empty_quotation_list">
        <template v-for="(item, i) in quotationsTableView">
          <v-row :key="i" no-gutters>
            <v-col>
              <v-card
                :color="getQuotationConfirmationStatus(item).bg"
                tile
                class="elevation-3"
              >
                <v-card-text class="pt-0 pb-1 pr-0">
                  <v-row no-gutters>
                    <v-col cols="10">
                      <v-row no-gutters>
                        <v-col
                          cols="2"
                          class="pt-1 d-flex justify-content-start"
                        >
                          <span class="font-weight-bold caption black--text">
                            <v-icon size="20" color="primary">{{
                              getQuotationType(item).icon
                            }}</v-icon>
                            {{ item.quotation_id }}
                          </span>
                        </v-col>

                        <v-col cols="3" class="pt-1">
                          <v-row no-gutters>
                            <v-chip
                              x-small
                              class="pa-1 mr-2 font-weight-bold overline"
                              label
                              outlined
                              :color="getTransactionType(item).color"
                              >{{ getTransactionType(item).title }}</v-chip
                            >

                            <v-chip
                              x-small
                              class="pa-1 mx-2 font-weight-bold overline"
                              label
                              outlined
                              >{{ getQuotationType(item).title }}</v-chip
                            >

                            <v-chip
                              x-small
                              class="pa-1 mx-2 font-weight-bold overline"
                              label
                              outlined
                              >{{ item.incoterm }}</v-chip
                            >

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  class="mx-1"
                                  :color="getCargoType(item).color"
                                  size="14"
                                  >{{ getCargoType(item).icon }}</v-icon
                                >
                              </template>
                              {{ item.commodity || getCargoType(item).title }}
                            </v-tooltip>
                          </v-row>
                        </v-col>

                        <v-col cols="3" class="ml-2">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span
                                v-on="on"
                                class="
                                  font-weight-bold
                                  caption
                                  black--text
                                  ml-2
                                "
                              >
                                <v-icon
                                  size="10"
                                  left
                                  color="primary"
                                  class="mr-0 pb-1"
                                  >mdi-checkbox-blank-circle</v-icon
                                >
                                {{ item.origin_port.un_code }}
                              </span>
                            </template>
                            {{ getOriginLabel(item) }}
                          </v-tooltip>

                          <span class="mx-1">------</span>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <span
                                v-on="on"
                                class="font-weight-bold caption black--text"
                              >
                                <v-icon
                                  size="10"
                                  left
                                  color="error"
                                  class="mr-0 pb-1"
                                  >mdi-checkbox-blank-circle</v-icon
                                >
                                {{ item.destination_port.un_code }}
                              </span>
                            </template>
                            {{ getDestinationLabel(item) }}
                          </v-tooltip>
                        </v-col>

                        <v-col class="pt-1">
                          <v-row no-gutters>
                            <span class="overline black--text mr-2">
                              <strong>CRD:</strong>
                              {{ item.crd_string }}
                            </span>

                            <span
                              class="overline black--text ml-2"
                              v-if="
                                item.shipment_schedule != null &&
                                !CONSTANT.isObjectEmpty(item.shipment_schedule)
                              "
                            >
                              <strong>ETA:</strong>
                              {{
                                item.transaction_type == "EXPORT"
                                  ? item.shipment_schedule.origin_eta_string
                                  : item.shipment_schedule
                                      .destination_eta_string
                              }}
                            </span>
                            <v-tooltip right v-else>
                              <template v-slot:activator="{ on }">
                                <span
                                  class="overline black--text ml-2"
                                  v-on="on"
                                >
                                  <strong>ETA:</strong> N/A
                                </span>
                              </template>
                              No freight schedule selected
                            </v-tooltip>

                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <span
                                  v-on="on"
                                  class="
                                    overline
                                    black--text
                                    ml-4
                                    text-lowercase
                                  "
                                  >updated: {{ item.updated }}</span
                                >
                              </template>
                              <span class="caption white--text"
                                >created on {{ item.created }}</span
                              >
                            </v-tooltip>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col
                      class="d-flex justify-end"
                      v-if="getQuotationConfirmationStatus(item).show"
                    >
                      <v-chip
                        x-small
                        class="px-1 font-weight-bold caption"
                        label
                        :color="getQuotationConfirmationStatus(item).color"
                        text-color="white"
                        >{{
                          getQuotationConfirmationStatus(item).title
                        }}</v-chip
                      >
                    </v-col>
                    <v-col v-else>
                      <v-row no-gutters justify="end">
                        <template v-if="!item.trash">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                x-small
                                tile
                                outlined
                                color="primary"
                                class="font-weight-bold mr-2 px-1 mt-1"
                                @click="onProposeQuotation(item)"
                                v-show="
                                  $root.is_admin &&
                                  item.status <
                                    CONSTANT.STATUS.QUOTATION.PROPOSED
                                "
                                >PROPOSE</v-btn
                              >
                            </template>
                            Accept & Propose Quotation to Customer
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                x-small
                                tile
                                outlined
                                color="green darken-3"
                                class="font-weight-bold mr-2 px-1 mt-1"
                                @click="onConfirmQuotation(item)"
                                v-show="
                                  item.status >=
                                    CONSTANT.STATUS.QUOTATION.PROPOSED &&
                                  item.status <
                                    CONSTANT.STATUS.QUOTATION.CONFIRMED
                                "
                                :disabled="
                                  item.status <
                                  CONSTANT.STATUS.QUOTATION.PROPOSED
                                "
                                >CONFIRM</v-btn
                              >
                            </template>
                            Click to confirm quotation
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                x-small
                                icon
                                color="error"
                                class="pt-1 mx-1"
                                @click="onQuotationDelete(item)"
                                v-if="
                                  $root.is_admin &&
                                  showConfirmDeleteQuotation(item)
                                "
                              >
                                <v-icon size="27">mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            Delete quotation
                          </v-tooltip>
                        </template>

                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                x-small
                                tile
                                outlined
                                color="error"
                                class="font-weight-bold mr-2 px-1 mt-1"
                                @click="onQuotationRestore(item)"
                                >RESTORE</v-btn
                              >
                            </template>
                            Restore quotation
                          </v-tooltip>
                        </template>
                      </v-row>
                    </v-col>
                  </v-row>

                  <!-- <v-row justify="start" class="mt-1 mb-2 pl-6">
                    <template v-for="inv in item.invoices">
                      <v-chip
                        :key="inv"
                        x-small
                        color="secondary"
                        outlined
                        label
                        ripple
                        class="pa-2 mr-2 font-weight-bold overline"
                        @click="onManageInvoice(inv)"
                        >{{ inv }}</v-chip
                      >
                    </template>
                  </v-row> -->

                  <v-row no-gutters>
                    <v-col>
                      <v-row justify="start" v-if="!item.trash">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              x-small
                              icon
                              color="primary"
                              class="font-weight-bold pt-2 mr-2"
                              @click="
                                onQuotationDialog(
                                  item,
                                  CONSTANT.DIALOG_QUOTATION_FILES
                                )
                              "
                            >
                              <v-icon size="22">mdi-file-upload</v-icon>
                            </v-btn>
                          </template>
                          Upload quotation files
                        </v-tooltip>

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              x-small
                              icon
                              color="primary"
                              class="font-weight-bold pt-2 mx-2"
                              @click="onQuotationOverview(item)"
                            >
                              <v-icon size="23">mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          View quotation details
                        </v-tooltip>

                        <template v-if="$root.is_admin">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                x-small
                                icon
                                color="#0D2C54"
                                class="pt-2 mx-2"
                                @click="onManageQuotation(item)"
                              >
                                <v-icon size="23"
                                  >mdi-square-edit-outline</v-icon
                                >
                              </v-btn>
                            </template>
                            Edit Quotation
                          </v-tooltip>

                          <!-- <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                x-small
                                icon
                                color="#0D2C54"
                                class="pt-2 mx-2"
                                @click="onIssueQuotationInvoice(item)"
                                v-show="item.confirmed"
                              >
                                <v-icon size="23">mdi-receipt</v-icon>
                              </v-btn>
                            </template>
                            Issue a new invoice
                          </v-tooltip> -->

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                x-small
                                icon
                                color="#0D2C54"
                                class="pt-2 mx-2"
                                @click="onSendQuotation(item)"
                              >
                                <v-icon size="23">mdi-email-send</v-icon>
                              </v-btn>
                            </template>
                            Send quotation to customer
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-badge
                                class="font-weight-bold"
                                :content="message_count[item.quotation_id]"
                                :value="message_count[item.quotation_id]"
                                color="amber darken-4"
                                overlap
                                bordered
                                offset-x="20"
                                offset-y="11"
                              >
                                <v-btn
                                  class="pt-2 mx-2"
                                  v-on="on"
                                  icon
                                  x-small
                                  @click="onViewMessages(item)"
                                >
                                  <v-icon size="23" color="#0D2C54"
                                    >mdi-message-text</v-icon
                                  >
                                </v-btn>
                              </v-badge>
                            </template>
                            View and post comments
                          </v-tooltip>

                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                v-on="on"
                                v-show="
                                  !item.has_shipment && $root.is_super_admin
                                "
                                x-small
                                class="pt-2 ml-2"
                                icon
                                @click="onAdminCreateShipment(item)"
                              >
                                <v-icon size="23" color="#0D2C54">{{
                                  getQuotationType(item).btn_icon
                                }}</v-icon>
                              </v-btn>
                            </template>
                            Create shipment for unconfirmed quotation
                          </v-tooltip>
                        </template>
                      </v-row>
                    </v-col>

                    <v-col cols="5" class="pt-2">
                      <v-row justify="space-between">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <span
                              v-if="$root.is_admin"
                              v-on="on"
                              class="
                                font-weight-medium
                                caption
                                text-uppercase
                                black--text
                                mr-4
                              "
                              >{{ item.company.short_name }}</span
                            >
                          </template>
                          {{ item.company.name }}
                        </v-tooltip>

                        <!-- <template v-if="item.status != CONSTANT.STATUS.QUOTATION.CONFIRMED"> -->
                        <template>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-chip
                                v-on="on"
                                class="
                                  pa-1
                                  mx-4
                                  font-weight-bold
                                  caption
                                  text-wrap
                                "
                                x-small
                                label
                                dark
                                :color="getQuotationStatus(item).color"
                                >{{ getQuotationStatus(item).title }}</v-chip
                              >
                            </template>
                            {{ getQuotationStatus(item).msg }}
                          </v-tooltip>
                        </template>

                        <template
                          v-if="
                            item.has_complete_price ||
                            item.override_has_complete_price
                          "
                        >
                          <span class="font-weight-bold black--text pr-2"
                            >{{ item.currency }}
                            {{
                              item.price_estimate_total != null
                                ? item.price_estimate_total.toLocaleString(
                                    "en-US",
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )
                                : "TBC"
                            }}</span
                          >
                        </template>

                        <template v-else>
                          <v-tooltip left>
                            <template v-slot:activator="{ on }">
                              <span
                                v-on="on"
                                class="font-weight-bold black--text pr-2"
                              >
                                TBC
                              </span>
                            </template>
                            Incomplete price
                          </v-tooltip>
                        </template>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
          <v-divider :key="`${i}divider`"></v-divider>
        </template>
      </v-col>

      <v-col v-else class="mt-10 pa-10">
        <v-alert tile dense prominent type="error">
          <v-row align="center">
            <v-col v-if="selectedCompany != null" class="grow">
              <strong>{{ selectedCompany.name }}</strong> does not have any
              Quotation at the moment
            </v-col>
            <v-col v-else class="grow">Quotation list is empty</v-col>
            <v-col class="shrink">
              <v-btn class="font-weight-bold" @click="onCreateQuotation"
                >CREATE QUOTATION</v-btn
              >
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
import constant from "../../const"
import moment from "moment"
import flatPickr from "vue-flatpickr-component"
import "flatpickr/dist/flatpickr.css"
import "flatpickr/dist/themes/airbnb.css"
import DialogManageQuotation from "@/components/admin/dialogs/DialogManageQuotation"
import DialogQuotationOverview from "@/components/user/DialogQuotationOverview"
import DialogManageInvoice from "@/components/admin/dialogs/DialogManageInvoice"
import DialogQuotationFiles from "@/components/user/DialogQuotationFiles"
import DialogFileCabinet from "@/components/user/DialogFileCabinet.vue"
import DialogMessageBox from "@/components/user/DialogMessageBox.vue"

import AFPagination from "@/components/shared/AFPagination"

export default {
  components: {
    flatPickr,
    DialogManageQuotation,
    DialogQuotationOverview,
    DialogManageInvoice,
    DialogQuotationFiles,
    DialogFileCabinet,
    DialogMessageBox,
    "af-pagination": AFPagination,
  },

  data() {
    return {
      CONSTANT: constant,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 6000,
      alert: false,
      alertType: "success",
      alertMessage: "",

      config: {
        altInput: true,
        altInputClass: "flatpickr-alt-input-filter",
        // enableTime: true,
        altFormat: "M j, Y",
        dateFormat: "Y-m-d",
        // time_24hr: true,
        position: "auto",
      },

      dialogOnConfirmQuotation: false,
      selected_tbc_quotation: null,

      dialogShipmentType: false,
      dialogQuotation: false,

      dialogNewQuotation: false,

      dialogManageQuotation: false,
      dialogQuotationOverview: false,

      dialogManageInvoice: false,
      selectedInvoice: null,

      dialogQuotationFiles: false,
      dialogScheduleList: false,

      dialogAdminCreateShipment: false,

      dialogFilterQuotation: false,

      dialogMessageBox: false,
      messageBoxTitle: null,
      messageBoxQuotationId: null,
      messageBoxInvoiceId: null,
      messageBoxCompanyId: null,
      messageBoxCompanyName: null,
      messageBoxCategory: "quotation",
      messageBoxTags: [],

      dialogSendQuotation: false,
      email_data: {
        quotation_id: null,
        from: `${this.$root.username} <${this.$root.useraccount.email}>`,
        to: null,
        cc: null,
        bcc: null,
        subject: null,
        body: null,
      },

      rules: {
        required: (value) => !!value || "Required.",
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || "Invalid e-mail."
        },
      },

      customToolbar: [
        [
          {
            header: [false, 1, 2, 3, 4, 5, 6],
          },
        ],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
      ],

      dialogFileCabinet: false,
      selectedBookingInfo: null,
      selectedShipmentId: null,
      selectedCompanyId: null,

      selectedQuotation: null,
      selectedQuotationSync: {},
      selectedQuotationOverview: null,

      selectedCompany: null,
      companies: [],

      shipmentTypeFilters: ["FCL", "LCL", "AIR"],
      dateRangeFilters: [
        {
          id: 0,
          label: "Cargo ready date",
        },
        {
          id: 1,
          label: "Quotation created date",
        },
      ],
      portList: [],

      selectedQuotationStatusFilter: 0,

      selectedShipmentTypeFilter: null,

      selectedOriginPortFilter: null,
      selectedDestPortFilter: null,

      selectedDateRangeFilter: null,

      selectedStartFilter: null,
      selectedEndFilter: null,

      quotation_id_search: null,

      isResetFilter: true,

      pagination: {
        sortBy: ["countid"],
        sortDesc: [true],
        page: 1,
        itemsPerPage: 20,
        totalItems: 0,
      },

      quotations: [],
      quotationsTableView: [],
      empty_quotation_list: false,

      // message_listener: {},
      message_count: {},
    }
  },

  async created() {
    this.$root.fullScreenView = false
    this.$root.blockUImsg = "Loading quotations"
    this.$root.blockUIshow = true

    // verify user token
    await this.$root.verify_user_token()

    this.initializeFilters()
    this.initializeQuotationsList(false)
  },
  mounted() {},

  watch: {},

  methods: {
    /**
     * fetch ports
     */
    async fetch_ports() {
      let resp = await this.$https.get("/api/ports")
      this.portList = resp.data.data || []
    },

    /**
     * Load companies
     */
    async loadCompanies() {
      if (this.$root.is_admin) {
        let resp = await this.$https.get("/api/company/list")
        this.companies = resp.data.data || []
      }
    },

    /**
     * Initialise the filters
     */
    async initializeFilters() {
      this.loadCompanies()
      this.fetch_ports()

      this.selectedStartFilter = moment().startOf("month").format("YYYY-MM-DD") // default to start of the current month
      this.selectedEndFilter = moment().endOf("month").format("YYYY-MM-DD") // default to end of the current month
    },

    /**
     * Reset the filters
     */
    resetFilters() {
      this.selectedCompany = null
      this.selectedQuotationStatusFilter = 0

      this.selectedShipmentTypeFilter = null

      this.selectedOriginPortFilter = null
      this.selectedDestPortFilter = null

      this.selectedDateRangeFilter = null

      this.selectedStartFilter = null
      this.selectedEndFilter = null

      this.quotation_id_search = null

      this.isResetFilter = true
    },

    /**
     * On reset filters and refresh quotation list
     */
    onResetRefreshQuotationList() {
      this.resetFilters()
      this.initializeQuotationsList(false)
    },

    /**
     * On create a new quotation
     */
    async onCreateQuotation() {
      this.$root.blockUImsg = "Initialising..."
      this.$root.blockUIshow = true
      // verify user token
      await this.$root.verify_user_token()
      this.$root.blockUIshow = false

      this.dialogNewQuotation = true
    },

    onQuotationClick(quotation, props) {
      props.expanded = !props.expanded
    },

    getRowBackgroundColor: function (quotation) {
      var color = "transparent"

      if (
        this.selectedQuotation != null &&
        this.selectedQuotation == quotation
      ) {
        color = "#007EA7"
      }

      return color
    },

    refreshQuotationsViewList() {
      this.quotationsTableView = this.quotations.slice(
        (this.pagination.page - 1) * this.pagination.itemsPerPage,
        this.pagination.page * this.pagination.itemsPerPage
      )
    },

    initializeQuotationsList(isAppend) {
      this.$root.blockUImsg = "Loading quotations"
      this.$root.blockUIshow = true

      let requestString =
        "/api/quotations/list?limit=" + this.pagination.itemsPerPage

      // let requestString = "/api/quotations/list?limit=2";

      // if it is a quotation id search
      if (this.quotation_id_search != null) {
        if (this.quotation_id_search.length > 0) {
          requestString = `/api/quotations/list?quotation_id=${this.quotation_id_search}&trash=-1`
        }
      } else {
        switch (this.selectedQuotationStatusFilter) {
          // Draft
          case 1:
            requestString = requestString + "&draft=true"
            break
          // Proposed
          case 2:
            requestString = requestString + "&proposed=true"
            break
          // confirmed
          case 3:
            requestString = requestString + "&confirmed=true"
            break
          // trash
          case 4:
            requestString = requestString + "&trash=true"
            break
          default:
            break
        }

        // append the advanced filters
        // if shipment type filter selected
        if (this.selectedShipmentTypeFilter != null) {
          requestString = `${requestString}&q_type=${this.selectedShipmentTypeFilter}`
        }

        // if origin port filter selected
        if (this.selectedOriginPortFilter != null) {
          requestString = `${requestString}&op_un_code=${this.selectedOriginPortFilter}`
        }

        // if destination port filter selected
        if (this.selectedDestPortFilter != null) {
          requestString = `${requestString}&dp_un_code=${this.selectedDestPortFilter}`
        }

        // if company was selected to filered by
        if (this.selectedCompany != null) {
          requestString =
            requestString + "&company_id=" + this.selectedCompany.company_id
        }

        // iif date range filter is not null
        if (this.selectedDateRangeFilter != null) {
          // validate start and end date
          if (
            this.selectedStartFilter == null ||
            this.selectedEndFilter == null ||
            this.selectedStartFilter.length == 0 ||
            this.selectedEndFilter.length == 0
          ) {
            this.showSnackbar = true
            this.snackbarColor = "error"
            this.snackbarMsg = "Invalid input for either start or end date"
            this.$root.blockUIshow = false
            return
          }

          if (this.selectedDateRangeFilter == 0) {
            requestString = `${requestString}&filter_by_crd=true&start_crd=${this.selectedStartFilter}&end_crd=${this.selectedEndFilter}`
          } else if (this.selectedDateRangeFilter == 1) {
            requestString = `${requestString}&filter_by_created=true&start_crd=${this.selectedStartFilter}&end_crd=${this.selectedEndFilter}`
          }
        }
      }

      if (isAppend && this.pagination.next_cursor != null) {
        this.quotation_id_search = null
        requestString = requestString + "&cursor=" + this.pagination.next_cursor
      } else {
        this.quotations = []
        this.pagination.totalItems = 0
        this.pagination.next_cursor = null
        this.pagination.page = 1
      }

      this.$https
        .get(requestString)
        .then((resp) => {
          var response = resp.data
          if (response.status == constant.RESPONSE_STATUS_OK) {
            this.empty_quotation_list = false

            // initialise the message count object
            response.data.data.forEach((element) => {
              this.$set(this.message_count, element.quotation_id, 0)
            })

            this.quotations.push(...response.data.data)

            if (response.data.count > 0) {
              this.pagination.totalItems = response.data.count
            }

            this.pagination.next_cursor = response.data.next_cursor

            this.refreshQuotationsViewList()
            this.$root.blockUIshow = false

            // set the comment messages for each quotation
            const firestore_db = this.$root.messageCenterApp.firestore()
            response.data.data.forEach((element) => {
              this.setMessageCount(firestore_db, element)
            })
          } else if (response.status == constant.RESPONSE_STATUS_EMPTY) {
            this.empty_quotation_list = true
            this.$root.blockUIshow = false
          } else {
            console.log("Error loading quotations list", response)
            this.showSnackbar = true
            this.snackbarColor = "error"
            this.snackbarMsg = response.msg
            this.$root.blockUIshow = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.showSnackbar = true
          this.snackbarColor = "error"
          this.snackbarMsg = err
          this.$root.blockUIshow = false
        })
    },

    // Pagination methods

    onNextPage() {
      let isLastPageLoaded =
        this.pagination.itemsPerPage * (this.pagination.page - 1) ==
        this.quotations.length

      if (isLastPageLoaded) {
        this.initializeQuotationsList(true)
      } else {
        this.refreshQuotationsViewList()
      }
    },

    onPrevPage() {
      this.refreshQuotationsViewList()
    },

    onitemsPerPageChange() {
      this.initializeQuotationsList(false)
    },

    // End pagination methods

    /**
     * on open dialog filter quotation list
     */
    onOpenDialogFilterQuotation() {
      this.dialogFilterQuotation = true
    },

    /**
     * Get the quotation confirmation status
     * @param {object} quotation
     */
    getQuotationConfirmationStatus(quotation) {
      var color = ""
      var title = ""
      var bg = "white"
      var show = false

      if (quotation.confirmed && !quotation.issued_invoice) {
        color = "green darken-2"
        bg = "green lighten-5"
        title = "Confirmed"
        show = true
      } else if (quotation.confirmed && quotation.issued_invoice) {
        color = "#0D2C54"
        bg = "green lighten-5"
        title = "Invoice Issued"
        show = true
      } else {
        color = null
        bg = "white"
        title = null
        show = false
      }
      return { color: color, bg: bg, title: title, show: show }
    },

    /**
     * Get the quotation status
     * @param {object} quotation
     */
    getQuotationStatus(quotation) {
      var color = "grey darken-3"
      var msg = "Draft quotation, price to be finalized"
      var title = "Draft"

      switch (quotation.status) {
        case constant.STATUS.QUOTATION.EXPIRED:
          color = "error"
          title = "Expired"
          msg =
            "Quotation has already expired. Please refresh the quotation or create a new one"
          break
        case constant.STATUS.QUOTATION.DRAFT:
          break
        case constant.STATUS.QUOTATION.REQUEST:
          color = "black"
          title = "Request"
          msg = "A requested quotation from a customer"
          break
        case constant.STATUS.QUOTATION.PROPOSED:
          color = "amber darken-4"
          title = "Proposed"
          msg =
            "This quotation is proposed. Please confirm the quotation to proceed with booking"
          break
        case constant.STATUS.QUOTATION.PRICE_UPDATED:
          color = "teal darken-3"
          title = "Price Updated"
          msg =
            "A new price is updated for this quotation. Please confirm the quotation to proceed with booking"
          break
        case constant.STATUS.QUOTATION.CONFIRMED:
          color = "green darken-2"
          title = "Accepted"
          msg = "This quotation is confirmed. Shipment is in progress."
          break
        case constant.STATUS.QUOTATION.SHIPMENT_COMPLETED:
          color = "teal darken-4"
          title = "Shipment Completed"
          msg =
            "The shipment is completed, your invoice will be issued shortly."
          break
        case constant.STATUS.QUOTATION.INVOICE_ISSUED:
          color = "teal darken-4"
          title = "Shipment Completed"
          msg =
            "The shipment is completed, your invoice will be issued shortly."
          break
        case constant.STATUS.QUOTATION.INVOICE_PAID:
          color = "green darken-2"
          title = "Invoice Paid"
          msg =
            "This quotation is closed, you may only review this for reference."
          break
        default:
          title = null
          msg = "This quotation has no status"
          break
      }
      return { color: color, title: title, msg: msg }
    },

    /**
     * Get the shipment type
     * @param {object} quotation
     */
    getQuotationType(quotation) {
      var color = "error"
      var title = ""
      var icon = "mdi-alert-circle"
      var btn_icon = "mdi-alert-circle"

      switch (quotation.quotation_type) {
        case constant.QUOTATION_TYPE_SEA_FCL:
          color = "light-blue darken-4"
          title = "FCL"
          icon = "mdi-ferry"
          btn_icon = "mdi-ferry"
          if (quotation.containers.length == 1) {
            if (quotation.containers[0].container_size == 20) {
              title = "FCL 20'"
            } else if (quotation.containers[0].container_size == 40) {
              title = "FCL 40'"
            }
          } else {
            let csizes = []
            quotation.containers.forEach((container) => {
              csizes.push(`F${container.container_size}'`)
            })
            title = `${csizes.join(" | ")}`
          }
          break
        case constant.QUOTATION_TYPE_SEA_LCL:
          color = "accent"
          title = "LCL"
          icon = "mdi-ferry"
          btn_icon = "mdi-ferry"
          break
        case constant.QUOTATION_TYPE_AIR:
          color = "secondary"
          title = "AIR"
          icon = "mdi-airplane-takeoff"
          btn_icon = "mdi-airplane"
          break
        case constant.QUOTATION_TYPE_WAREHOUSE:
          color = "blue-grey"
          title = "WH"
          icon = "mdi-warehouse"
          btn_icon = "mdi-warehouse"
          break
        default:
          break
      }

      return { icon: icon, btn_icon: btn_icon, color: color, title: title }
    },

    getTransactionType(quotation) {
      var color = ""
      var title = ""

      if (quotation.transaction_type == "EXPORT") {
        color = "#8F2D56"
        title = "EXP"
      } else if (quotation.transaction_type == "IMPORT") {
        color = "#3CAEA3"
        title = "IMP"
      }

      return { color: color, title: title }
    },

    /**
     * Get the cargo type
     * @param {object} quotation
     */
    getCargoType(quotation) {
      var color = "brown"
      var title = ""
      var icon = "fa-box"

      switch (quotation.cargo_type_code) {
        case "DG-2":
          title = quotation.cargo_type_code + ": Gases"
          color = "deep-orange lighten-1"
          icon = "fa-burn"
          break
        case "DG-3":
          title = quotation.cargo_type_code + ": Flammable liquids"
          color = "error"
          icon = "fa-fire"
          break
        case "NON-DG":
          title = quotation.cargo_type_code + ": Non dangerous goods"
          color = "brown lighten-1"
          break
      }

      return { icon: icon, color: color, title: title }
    },

    getOtherServiceStatus: function (quotation) {
      var statusColor = "deep-orange"
      var message = "Pending price update for other services"

      if (quotation.include_other_services) {
        if (quotation.has_other_services_price) {
          statusColor = "success"
          message = "Other services price updated"
        }
      }

      return { icon: "info", color: statusColor, msg: message }
    },

    getOriginLabel: function (quotation) {
      if (
        quotation.quotation_type == constant.QUOTATION_TYPE_SEA_FCL ||
        quotation.quotation_type == constant.QUOTATION_TYPE_SEA_LCL ||
        quotation.quotation_type == constant.QUOTATION_TYPE_AIR
      ) {
        return quotation.origin_port.label
      } else {
        return ""
      }
    },

    getDestinationLabel: function (quotation) {
      if (
        quotation.quotation_type == constant.QUOTATION_TYPE_SEA_FCL ||
        quotation.quotation_type == constant.QUOTATION_TYPE_SEA_LCL ||
        quotation.quotation_type == constant.QUOTATION_TYPE_AIR
      ) {
        return quotation.destination_port.label
      } else {
        return ""
      }
    },

    showConfirmDeleteQuotation: function (quotation) {
      return quotation.status < constant.STATUS.QUOTATION.CONFIRMED
    },

    /**
     * On admin create shipment
     */
    onAdminCreateShipment(quotation) {
      this.dialogAdminCreateShipment = true
      this.selectedQuotationSync = quotation
    },

    /**
     * Admin create shipment for this quotation before confirmation
     */
    async adminCreateShipment() {
      this.$root.blockUImsg = "Creating shipment"
      this.$root.blockUIshow = true

      let resp = await this.$https.post(
        `/api/quotations/${this.selectedQuotationSync.quotation_id}/admin_create_shipment`
      )
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.dialogAdminCreateShipment = false
        this.showSnackbar = true
        this.snackbarColor = "success"
        this.snackbarMsg = resp.data.msg
        this.selectedQuotationSync.has_shipment = true
        this.selectedQuotationSync.admin_override = true
        this.selectedQuotationSync = null
      } else {
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = resp.data.msg
        console.log("Error saving quotation", resp.data)
      }
      this.$root.blockUIshow = false
    },

    /**
     * on close admin create shipment dialog
     */
    onCloseAdminCreateShipment() {
      this.dialogAdminCreateShipment = false
      this.selectedQuotationSync = null
    },

    /**
     *  on propose quotation
     */
    async onProposeQuotation(quotation) {
      this.$root.blockUImsg = "Proposing quotation"
      this.$root.blockUIshow = true

      let resp = await this.$https.put(
        `/api/quotations/${quotation.quotation_id}/status/${constant.STATUS.QUOTATION.PROPOSED}`
      )
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // update the quotation status
        quotation.status = constant.STATUS.QUOTATION.PROPOSED
        this.showSnackbar = true
        this.snackbarColor = "success"
        this.snackbarMsg = `Quotation ${quotation.quotation_id} proposed successfully`
      } else {
        console.log(resp.data)
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = resp.data.msg
      }
      this.$root.blockUIshow = false
    },

    /** On confirm Quotation */
    onConfirmQuotation(quotation) {
      this.selected_tbc_quotation = quotation
      this.dialogOnConfirmQuotation = true
    },

    /**
     *  Confirm quotation
     */
    confirmQuotation(quotation) {
      this.$root.blockUImsg = "Confirming quotation"
      this.$root.blockUIshow = true
      var response = null

      this.$https
        .post(`/api/quotations/${quotation.quotation_id}/confirm`)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          console.log(err)
          this.showSnackbar = true
          this.snackbarColor = "error"
          this.snackbarMsg = err
        })
        .finally(() => {
          if (response.status == constant.RESPONSE_STATUS_OK) {
            // update the quotation status
            quotation.status = constant.STATUS.QUOTATION.CONFIRMED
            quotation.confirmed = true
            quotation.has_shipment = true
            this.dialogOnConfirmQuotation = false
            // this.selected_tbc_quotation = null;
            this.$root.blockUIshow = false
            this.showSnackbar = true
            this.snackbarColor = "success"
            this.snackbarMsg = response.msg

            // start booking process
            this.onUploadBookingDocs(this.selected_tbc_quotation)
          } else {
            console.log(response)
            this.showSnackbar = true
            this.snackbarColor = "error"
            this.snackbarMsg = response.msg
          }
        })
    },

    onQuotationDelete(quotation) {
      this.$root.blockUImsg = "Deleting quotation..."
      this.$root.blockUIshow = true

      var response = null

      this.$https
        .delete(`/api/quotations/${quotation.quotation_id}`)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          if (response.status == constant.RESPONSE_STATUS_OK) {
            // update the quotation
            quotation.trash = true
            this.$root.blockUIshow = false
          }
        })
    },

    /**
     * On restore quotation
     */
    onQuotationRestore(quotation) {
      this.$root.blockUImsg = "Restoring quotation..."
      this.$root.blockUIshow = true

      var response = null

      this.$https
        .put(`/api/quotations/${quotation.quotation_id}/untrash`)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          if (response.status == constant.RESPONSE_STATUS_OK) {
            // update the quotation
            quotation.trash = false
            this.$root.blockUIshow = false
          }
        })
    },

    // Dialog management methods
    async onQuotationDialog(quotation, dialog) {
      this.$root.blockUImsg = "Loading quotation information"
      this.$root.blockUIshow = true
      // verify user token
      await this.$root.verify_user_token()
      var response = null

      this.$https
        .get(`/api/quotations/${quotation.quotation_id}`)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          if (response.status == constant.RESPONSE_STATUS_OK) {
            this.selectedQuotation = response.data

            switch (dialog) {
              case constant.DIALOG_SCHEDULE_LIST:
                this.dialogScheduleList = true
                break
              case constant.DIALOG_QUOTATION_OVERVIEW:
                this.selectedQuotationOverview = this.selectedQuotation
                this.dialogQuotationOverview = true
                break
              case constant.DIALOG_QUOTATION_FILES:
                this.dialogQuotationFiles = true
                break
            }
          }

          this.$root.blockUIshow = false
        })
    },

    async onManageQuotation(quotation) {
      this.$root.blockUImsg = "Loading quotation information"
      this.$root.blockUIshow = true
      // verify user token
      await this.$root.verify_user_token()

      let resp = await this.$https.get(
        `/api/quotations/${quotation.quotation_id}`
      )

      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // clone the selected quotation
        this.selectedQuotationSync = quotation

        // get the selected quotation
        this.selectedQuotation = resp.data.data
        this.dialogManageQuotation = true
      } else {
        console.log("OnManageQuotation Error: ", resp.data)
      }

      this.$root.blockUIshow = false
    },

    /**
     * On Create invoice
     */
    onIssueQuotationInvoice(quotation) {
      // let routeData = this.$router.resolve({
      //   name: "newinvoice",
      //   params: { id: quotation.quotation_id },
      // })
      // window.open(routeData.href + "?id=" + quotation.quotation_id, "_blank")
    },

    /**
     * on manage invoice
     */
    async onManageInvoice(invoice_id) {
      // // only admin can open this dialog
      // if (this.$root.is_admin) {
      //   this.$root.blockUImsg = "Loading invoice information"
      //   this.$root.blockUIshow = true
      //   // verify user token
      //   await this.$root.verify_user_token()
      //   var response = null
      //   this.$https
      //     .get(`/api/invoices/${invoice_id}`)
      //     .then((resp) => (response = resp.data))
      //     .catch((err) => {
      //       console.log(err)
      //     })
      //     .finally(() => {
      //       if (response.status == constant.RESPONSE_STATUS_OK) {
      //         this.selectedInvoice = response.data
      //         this.dialogManageInvoice = true
      //       } else {
      //         console.log("OnManageInvoice Error: ", response)
      //       }
      //       this.$root.blockUIshow = false
      //     })
      // }
    },

    /**
     * Set the comment message count for each quotation
     */
    setMessageCount(firestore_db, quotation) {
      // Get the message count and listen to the document
      firestore_db
        .collection("comments")
        .doc(quotation.quotation_id)
        .onSnapshot((doc) => {
          if (!doc.exists) {
            this.message_count[quotation.quotation_id] = 0
            // console.error("doc doesnt exist");
          } else {
            // get the message count number
            this.message_count[quotation.quotation_id] = doc.data().count
          }
        })
    },

    /**
     * On open the message box
     */
    onViewMessages(quotation) {
      this.messageBoxTitle = `Quotation ${quotation.quotation_id}`
      this.messageBoxQuotationId = quotation.quotation_id
      this.messageBoxInvoiceId = null
      this.messageBoxCompanyId = quotation.company.company_id
      this.messageBoxCompanyName = quotation.company.name
      this.messageBoxTags = [
        `${quotation.quotation_type.toLowerCase()}`,
        `${quotation.transaction_type.toLowerCase()}`,
        `${quotation.incoterm.toLowerCase()}`,
        `${quotation.cargo_type_code.toLowerCase()}`,
      ]
      this.dialogMessageBox = true
    },

    onQuotationOverview(quotation) {
      let routeData = this.$router.resolve({
        name: "quotationoverview",
        params: { id: quotation.quotation_id },
      })
      window.open(routeData.href + "?id=" + quotation.quotation_id, "_blank")
    },

    onQuotationScheduleList(quotation) {
      this.$root.blockUImsg = "Loading quotation information"
      this.$root.blockUIshow = true
      var response = null

      this.$https
        .get("/api/quotations/" + quotation.quotation_id)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          if (response.status == constant.RESPONSE_STATUS_OK) {
            this.selectedQuotation = response.data
            this.dialogScheduleList = true
          }

          this.$root.blockUIshow = false
        })
    },

    /**
     * on upload documents for booking
     */
    onUploadBookingDocs(quotation) {
      this.selectedShipmentId = quotation.quotation_id
      this.selectedCompanyId = quotation.company_id
      this.dialogFileCabinet = true
    },

    /** on open Send Quotation dialog */
    onSendQuotation(quotation) {
      this.email_data.quotation_id = quotation.quotation_id
      this.email_data.to = quotation.company.contact_info.email
      this.email_data.subject = `Quotation ${quotation.quotation_id} from Accele Freight Sdn Bhd`
      this.email_data.body = `Hi ${
        quotation.company.contact_info.first_name || ""
      },
Thank you for your enquiry.

Attached is your Quotation ${quotation.quotation_id} for ${
        quotation.currency
      } ${quotation.price_estimate_total.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}.

If you have any questions, please let us know.
Thanks,
Accele Freight Sdn Bhd
Terms`
      this.dialogSendQuotation = true
    },

    /** Send Quotation email */
    sendQuotationEmail() {
      const pattern =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      // check if recipient is valid
      if (!pattern.test(this.email_data.to) || this.email_data.to == null) {
        this.showSnackbar = true
        this.snackbarColor = "error"
        this.snackbarMsg = "Invalid recipient email address"
        return
      }

      this.$root.blockUIshow = true
      this.$root.blockUImsg = "Sending quotation"

      var response = null

      this.$https
        .post("/api/quotations/send_email", this.email_data)
        .then((resp) => (response = resp.data))
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          if (
            response != null &&
            response.status == constant.RESPONSE_STATUS_OK
          ) {
            this.showSnackbar = true
            this.snackbarColor = "success"
            this.snackbarMsg = "Quotation Email Sent"

            this.$root.blockUIshow = false

            this.dialogSendQuotation = false
            this.email_data = {
              quotation_id: null,
              from: `${this.$root.username} <${this.$root.useraccount.email}>`,
              to: null,
              cc: null,
              bcc: null,
              subject: null,
              body: null,
            }
          } else {
            this.showSnackbar = true
            this.snackbarColor = "error"
            this.snackbarMsg = response.msg
            console.log("Error sending quotation", response)
            this.$root.blockUIshow = false
          }
          this.$root.blockUIshow = false
        })
    },

    /**
     * On close new quotation dialog
     */
    onDialogNewQuotationClose(newQuotation, wasCreated) {
      this.dialogNewQuotation = false
      // if new quotation was created then unshift it into quotation list
      if (wasCreated) {
        // initialise the message count key for this new quotation
        this.$set(this.message_count, newQuotation.quotation_id, 0)

        // set the message count for this new quotation and listen to it
        const firestore_db = this.$root.messageCenterApp.firestore()
        this.setMessageCount(firestore_db, newQuotation)

        // append new quotation
        this.quotationsTableView.unshift(newQuotation)
      }
    },

    /**
     * On close Dialog Manage Quotation
     */
    onDialogManageQuotationClose(
      quotation,
      hasChange,
      isReAssigned = false,
      newCompany = null
    ) {
      this.dialogManageQuotation = false
      // sync only if hasChange is true but not re-assigned to another company
      if (hasChange && !isReAssigned) {
        // sync the updated quotation
        this.selectedQuotationSync = Object.assign(
          this.selectedQuotationSync,
          quotation
        )
      } else if (isReAssigned && newCompany != null) {
        this.selectedQuotationSync.company = newCompany
        this.selectedQuotationSync.company_id = newCompany.company_id
        this.selectedQuotationSync.currency = newCompany.preferred_currency
      }

      this.selectedQuotation = null
    },

    /**
     * on load filtered quotation list
     */
    onLoadFilteredQuotationList() {
      this.isResetFilter = false
      this.dialogFilterQuotation = false
      this.initializeQuotationsList(false)
    },

    /**
     * on close the dialog quotation list filter
     */
    onCloseDialogQuotationFilter() {
      this.dialogFilterQuotation = false
    },

    onDialogClose(dialogID, quotation, hasChange) {
      switch (dialogID) {
        case constant.DIALOG_MANAGE_INVOICE:
          this.dialogManageInvoice = false
          this.selectedInvoice = null
          break

        case constant.DIALOG_QUOTATION_OVERVIEW:
          this.dialogQuotationOverview = false
          this.selectedQuotationOverview = null
          break

        case constant.DIALOG_QUOTATION_FILES:
          this.dialogQuotationFiles = false
          break

        case constant.DIALOG_FILE_CABINET:
          this.dialogFileCabinet = false
          break

        case constant.DIALOG_MESSAGE_BOX:
          this.dialogMessageBox = false
          this.messageBoxTitle = null
          this.messageBoxQuotationId = null
          this.messageBoxInvoiceId = null
          this.messageBoxCompanyId = null
          this.messageBoxCompanyName = null
          this.messageBoxTags = null
          break
      }

      this.selected_tbc_quotation = null
      this.selectedBookingInfo = null
      this.selectedQuotation = null
      this.selectedShipmentId = null
      this.selectedCompanyId = null
    },
  },

  computed: {
    sortedCompanies: function () {
      return this.companies.sort(function (a, b) {
        return a.name.localeCompare(b.name)
      })
    },

    sortedPortList: function () {
      return this.portList.sort(function (a, b) {
        return a.label.localeCompare(b.label)
      })
    },
  },
}
</script>

<style scoped>
::v-deep .v-stepper__step__step {
  width: 25px;
  height: 25px;
  border-radius: 100%;
}
</style>
